import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'
import { TemedAutocomplete, IAutocompleteGroup } from '../TemedAutocomplete'
import * as DataService from '../../services/DataService';
import { IInsurance, ILocation } from '../../models';

import './SearchWidget.scss'
import { EventBus, SEARCH_WIDGET_EVENTS, TEMED_WIDGET_EVENTS } from '../../services/EventBus';
import { AppService } from '../../services/AppService';

@Component({
  template: require('./SearchWidget.html'),
  components:{
    'temed-autocomplete' : TemedAutocomplete
  }
})
export class SearchWidget extends Vue {

  @Prop({ default: 'Find a Doctor' })
  title: string;

  @Prop({ default: 'Specialty, Doctor, Practice name' })
  placeholder: string;

  @Prop({ default: 'Also search by Disease, Treatment, Symptoms' })
  alsoText: string;

  @Prop({ default: 'Find Now' })
  submitText: string;

  @Prop({ default: 'https://www.temed.com/' })
  url: string;

  appService: AppService;

  distances = ['5', '10', '15', '20', '25', '50+'];

  distance = '15';

  conditions = '';

  showForm = true;

  insurances: IInsurance[] = [];
  insurance = '';

  zip = '';

  practiceSearchOpen = false;
  practiceSearchItems: IAutocompleteGroup[] =[];
  practiceSelected = null;
  practiceSelectedSlug = 'default';
  practiceQuery = '';

  citySearchOpen = false;
  citySearchItems: IAutocompleteGroup[] =[];
  citySelected = null;
  cityQuery = '';

  userLocation: ILocation = null;

  created(){
    this.appService = AppService.getInstance();
  }

  mounted(){
    this.userLocation = this.appService.get('userLocation');

    EventBus.$on(SEARCH_WIDGET_EVENTS.SEARCH_TOGGLE_FORM, (show:boolean) => {
      this.toggle(show);
    });

    EventBus.$on(TEMED_WIDGET_EVENTS.GEO_LOCATION_CHANGED, () => {
      this.appService.getUserLocation()
        .then(location => {
          this.userLocation = location;
        }).catch(e => {
          console.log(e);
        });
    });

    DataService.getInsurances().then(response => {
      this.insurances = response.data;
    })
    .catch(e => {
      console.log(e);
    });
  }

  @Watch('userLocation')
  onUserLocationChange(){
    if(this.userLocation.country === 'US'){
      this.zip = this.userLocation.zip;
      DataService.searchCity(this.userLocation.zip).then(response => {
        if(response.data.items){
          this.citySelected = response.data.items[0];
        }
      }).catch(e => {
        console.log(e);
      });
    }
  }

  onPracticeSearch(searchString){
    this.practiceSelected = null;
    this.practiceSelectedSlug = 'default';
    if(searchString < 3){
      this.practiceSearchItems = [];
      this.practiceSearchOpen = false;
    }
    if(searchString && searchString.length >= 3){
      DataService.searchSmart(searchString).then(response => {
        const searchItems = [];
        if(response.data.doctors && response.data.doctors.length){
          searchItems.push({ title: 'DOCTORS', slug: 'doctor', items: response.data.doctors });
        }
        if(response.data.specialities && response.data.specialities.length){
          searchItems.push({ title: 'SPECIALITIES', slug: 'specialty', items: response.data.specialities });
        }
        if(response.data.symptoms && response.data.symptoms.length){
          searchItems.push({ title: 'SYMPTOMS', slug: 'symptoms', items: response.data.symptoms });
        }
        if(response.data.conditions && response.data.conditions.length){
          searchItems.push({ title: 'CONDITIONS', slug: 'conditions', items: response.data.conditions });
        }
        if(response.data.clinics && response.data.clinics.length){
          searchItems.push({ title: 'PRACTICES', slug: 'practice', items: response.data.clinics });
        }
        if(response.data.treatments && response.data.treatments.length){
          searchItems.push({ title: 'TREATMENTS', slug: 'treatments', items: response.data.treatments });
        }
        if(response.data.care && response.data.care.length){
          searchItems.push({ title: 'CARE', slug: 'care', items: response.data.care });
        }
        this.practiceSearchItems = searchItems;
        this.practiceSearchOpen = true;
      }).catch(e => {
        console.log(e);
      });
    }

  }

  onPracticeSelect(item, slug){
    this.practiceSearchOpen = false;
    this.practiceSelected = item;
    this.practiceSelectedSlug = slug;
  }

  onPracticeBlur(searchString){
    this.practiceQuery = searchString;
    this.practiceSearchOpen = false;
  }

  onCitySearch(searchString){
    this.citySelected = null;
    if(searchString < 2){
      this.citySearchItems = [];
      this.citySearchOpen = false;
    }

    if(searchString && searchString.length >= 3){
      DataService.searchCity(searchString).then(response => {
        const searchItems = [];
        if(response.data.items){
          searchItems.push({ title: 'CITIES', items: response.data.items });
        }
        this.citySearchItems = searchItems;
        this.citySearchOpen = true;
      }).catch(e => {
        console.log(e);
      });
    }
  }

  onCitySelect(item){
    this.citySearchOpen = false;
    this.citySelected = item;
    this.zip = item.zip;
  }

  onCityBlur(searchString){
    this.cityQuery = searchString;
    this.citySearchOpen = false;
  }

  searchTop(event){
    event.preventDefault();
    setTimeout(()=>{
      this.search(event);
    },0)
  }

  search(event){
    event.preventDefault();
    setTimeout(()=> {
      let link = `${this.url}doctors?`;

      if(!this.practiceSelected){

        if(this.practiceQuery.length){
          link += `default=${encodeURIComponent(this.practiceQuery)}`
        }else{
          link += 'default='
        }
      }else{
        const name = this.practiceSelected.name.replace(/ /g, '-').toLowerCase();
        link += `${this.practiceSelectedSlug}=${encodeURIComponent(name)}`;
        // link += `&q=${encodeURIComponent(this.practiceSelected.name)}`
      }

      if(this.insurance){
        link += '&insurance=' + encodeURIComponent(this.insurance);
      }

      if(this.citySelected){
        link += '&zip=' + this.citySelected.zip;
        link += '&distance=' + this.distance;
      }else{
        if(this.cityQuery.length){
          if(isNaN(parseInt(this.cityQuery))){
            link += '&city=' + encodeURIComponent(this.cityQuery);
          }else{
            link += '&zip=' + encodeURIComponent(this.cityQuery);
          }
          link += '&distance=' + this.distance;
        }
      }

      const win = window.open(link, '_blank');
      if (win) {
        // Browser has allowed it to be opened
        win.focus();
      }
    }, 0);
  }

  toggle(show: boolean){
    this.showForm = show;
  }

}
